const SDK_VERSION = '8.2.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
